/** Свободный текст «Что ищешь» (profiles.looking_for). */
export const LOOKING_FOR_MAX = 300;
/** Минимум символов для обязательного шага ARENA. */
export const SEEKING_MIN = 10;

/** Текст «что ищешь» достаточен для шага ARENA. */
export const hasSeekingText = (v: string | null | undefined) => (v ?? "").trim().length >= SEEKING_MIN;

/** Для сохранения: обрезаем пробелы и длину, пустое — null. */
export function normalizeLookingFor(v: string | null | undefined): string | null {
  const t = (v ?? "").trim().slice(0, LOOKING_FOR_MAX).trim();
  return t ? t : null;
}

/** Строка «Ищет: …» на карточке; null — не показывать. */
export function lookingForLine(v: string | null | undefined): string | null {
  const t = (v ?? "").trim();
  return t ? `Ищет: ${t}` : null;
}
